import { useEffect, useMemo, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { Chip, IconButton, Tooltip } from "@material-ui/core";
import { useInfiniteScrollForQuery } from "../../../../School/hooks";
import {
  GetContentTextbooksDocument,
  GetContentTextbooksQuery,
} from "../../../../../generated/graphql";
import { useDebounce } from "../../../../shared/Utils/OtherOperations/useDebounce";
import { LoadingProgress } from "../../../../shared/LoadingProgress";
import CancelIcon from "@material-ui/icons/Cancel";
import { ModalInput } from "../../../../shared/Style/Style";
import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import { LIMIT_TEXT_BOOKS } from "../../constants";
import { formatBookName } from "../../utils";

export const SelectContentTextBooks = () => {
  const [searchKey, setSearchKey] = useState("");
  const model = useReactiveVar(mobileAppModel.model);
  const selectedBooks = model?.libraryContent?.textbooks ?? [];
  const debouncedValue = useDebounce(searchKey, 500);
  const inputErrors = useReactiveVar(mobileAppModel.inputErrors);

  const variables = useMemo(
    () => ({
      skip: 0,
      search: debouncedValue,
    }),
    [debouncedValue]
  );

  const {
    items: textBooks,
    loading,
    handleScroll,
    loadMore,
  } = useInfiniteScrollForQuery<GetContentTextbooksQuery>({
    query: GetContentTextbooksDocument,
    variables,
    key: "data",
    getItems: (data) => data.getContentTextbooks?.textbooks || [],
    limitKey: "limit",
    limit: LIMIT_TEXT_BOOKS,
  });

  useEffect(() => {
    if (
      selectedBooks.length > 0 &&
      selectedBooks.length % LIMIT_TEXT_BOOKS === 0
    ) {
      loadMore();
    }
  }, [selectedBooks]);

  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      options={textBooks}
      style={{ maxWidth: "520px" }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => formatBookName(option, "класс")}
      value={selectedBooks}
      onChange={(_, value) => {
        mobileAppModel.setTextBooks(value);
        setSearchKey("");
        value.length <= LIMIT_TEXT_BOOKS
          ? mobileAppModel.setInputErrors("textbooks", false, "")
          : mobileAppModel.setInputErrors(
              "textbooks",
              true,
              "Вы не можете выбрать более 10 книг"
            );
      }}
      ListboxProps={{
        onScroll: handleScroll,
      }}
      inputValue={searchKey}
      onInputChange={(_, value) => setSearchKey(value)}
      noOptionsText="Данную книгу не найдено"
      renderTags={(value: any[], getTagProps) =>
        value.map((option, index) => {
          const formatedText = formatBookName(option, "класс");

          return (
            <Tooltip title={formatedText} placement="top">
              <Chip
                key={option.id}
                variant="default"
                label={formatedText}
                deleteIcon={
                  <IconButton size="small">
                    <CancelIcon fontSize="small" />
                  </IconButton>
                }
                style={{ width: "100%" }}
                {...getTagProps({ index })}
              />
            </Tooltip>
          );
        })
      }
      renderInput={(params) => (
        <>
          <ModalInput
            {...params}
            label="Книги"
            margin="normal"
            onChange={(e) => setSearchKey(e.target.value)}
            error={inputErrors.textbooks.error}
            helperText={inputErrors.textbooks.message}
          />
          {loading && <LoadingProgress />}
        </>
      )}
    />
  );
};
